export default {
  label: 'Servicekosten rekenen op tafelbestellingen',
  description: 'Tafelbestellingen betalen geen servicekosten, tenzij dit aan staat.',
  no_fee: 'Je restaurant rekent geen servicekosten, dus tafelbestellingen betalen ook niets.',
  partner_default_on: 'Standaard van partner: aan',
  partner_default_off: 'Standaard van partner: uit',
  toasts: {
    on: 'Tafelbestellingen betalen nu servicekosten',
    off: 'Tafelbestellingen betalen nu geen servicekosten',
    error: 'Opslaan is niet gelukt. Probeer het opnieuw.',
  },
};
